import React, { useRef } from 'react';
import { useMindAR } from '../hooks/useMindAR';
import './MindARViewer.css';

const MindARViewer = ({ onProductSelect, onShowHelp }) => {
  const containerRef = useRef();

  const {
    isARReady,
    isTracking,
  } = useMindAR(containerRef, onProductSelect, onShowHelp);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        ref={containerRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }}
      />

      {isARReady && (
        <>
          {!isTracking && (
            <div className="scanning-frame">
              {/* Corner decorations */}
              <div className="corner-decoration top-left" />
              <div className="corner-decoration top-right" />
              <div className="corner-decoration bottom-left" />
              <div className="corner-decoration bottom-right" />
            </div>
          )}

          {/* Help Button */}
          <div style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: 100
          }}>
            <button
              className="help-button"
              onClick={onShowHelp}>
              ?
            </button>
          </div>
        </>
      )}

      {!isARReady && (
        <div className="loading-overlay">
          <div>Cargando Experiencia Dove AR...</div>
        </div>
      )}
    </div>
  );
};

export default MindARViewer;
